import { EMPLOYEE_TYPES } from '@/lib/constants/employeeTypes'

let getEmployeeTypeLabel = (employeeTypeId) => {
  return EMPLOYEE_TYPES[employeeTypeId].name
}

export default getEmployeeTypeLabel
